export default __webpack_public_path__ + "static/media/tutorial_robot_right@2x.f0bd485c.png";